"use client";

import { useState } from "react";
import Logo from "../../../assets/images/enedem.png";
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";
import { set } from "date-fns";

export default function Example() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <header className={"sticky w-full top-0 isolate bg-white z-50"}>
            <nav
                aria-label="Global"
                className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8 space-x-4"
            >
                <div className="flex lg:flex-1">
                    <a href="/" className="-m-1.5 p-1.5">
                        <span className="sr-only">En Edem</span>
                        <img alt="" src={Logo} className="h-4 md:h-8 w-auto" />
                    </a>
                </div>
                {/* Desktop Navigation */}
                <div className="hidden lg:flex items-center space-x-4">
                    <a href="/admin/speisekarten">Speisekarten</a>
                    <a href="/admin/bestellungen">Bestellungen</a>
                    <a href="/admin/popups">Popups</a>
                    <a href="/admin/einstellungen">Einstellungen</a>
                    <button
                        onClick={() => {
                            localStorage.removeItem("token");
                            window.location.href = "/login";
                        }}
                        className="ml-4 bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                    >
                        Logout
                    </button>
                </div>
                {/* Mobile Menu Button */}
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        onClick={() => {
                            setMobileMenuOpen(!mobileMenuOpen);
                        }}
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        aria-expanded={mobileMenuOpen}
                        aria-controls="mobile-menu"
                    >
                        <span className="sr-only">Hauptmenü</span>
                        <Bars3Icon aria-hidden="true" className="size-6" />
                    </button>
                </div>
            </nav>
            <Dialog
                open={mobileMenuOpen}
                onClose={() => setMobileMenuOpen(false)}
                className="lg:hidden"
            >
                <div className="fixed inset-0 z-10" />
                <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="flex items-center justify-between mb-4">
                        <span />
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(false)}
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon aria-hidden="true" className="size-6" />
                        </button>
                    </div>
                    <div className="mt-6 flex flex-col h-[calc(100vh-80px)]">
                        <div className="-my-6 divide-y divide-gray-500/10 flex-1">
                            <div className="space-y-2 py-6 flex flex-col">
                                <a
                                    href="#"
                                    className="block rounded-lg py-2 px-3 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setMobileMenuOpen(false);
                                        navigate("/admin/speisekarten");
                                    }}
                                >
                                    Speisekarten
                                </a>
                                <a
                                    href="#"
                                    className="block rounded-lg py-2 px-3 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setMobileMenuOpen(false);
                                        navigate("/admin/bestellungen");
                                    }}
                                >
                                    Bestellungen
                                </a>
                                <a
                                    href="#"
                                    className="block rounded-lg py-2 px-3 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setMobileMenuOpen(false);
                                        navigate("/admin/popups");
                                    }}
                                >
                                    Popups
                                </a>
                                <a
                                    href="#"
                                    className="block rounded-lg py-2 px-3 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setMobileMenuOpen(false);
                                        navigate("/admin/einstellungen");
                                    }}
                                >
                                    Einstellungen
                                </a>
                            </div>
                        </div>
                        <button
                            onClick={() => {
                                localStorage.removeItem("token");
                                setMobileMenuOpen(false);
                                navigate("/login");
                            }}
                            className="mb-2 bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 w-full text-left"
                        >
                            Logout
                        </button>
                    </div>
                </DialogPanel>
            </Dialog>
        </header>
    );
}
